import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"

export function useMarkNotificationsAsReadMutation(
  notificationId: string | number
) {
  return useGenereicMutation<Record<string, unknown>>({
    createEndpoint: () => ENDPOINTS.notifications.markReadById(notificationId),
    method: HTTP_METHODS.POST,
    invalidationKeys: [QUERY_KEYS.notifications.index()],
    silent: true,
  })
}
export function useMarkAllNotificationsAsReadMutation() {
  return useGenereicMutation<Record<string, unknown>>({
    createEndpoint: () => ENDPOINTS.notifications.markAllRead(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [QUERY_KEYS.notifications.index()],
    silent: true,
  })
}
